var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NutrientAmountSelection',{attrs:{"calculation":_vm.calculation,"calculationNutrients":_vm.calculationNutrients,"averageDosage":_vm.calculation.averageDosage ?? null,"disableAmountLine":_vm.disableAmountLine},on:{"update:nutrient":_vm.updateNutrient,"update:nutrientAmount":_vm.updateNutrientAmount}})
}
var staticRenderFns = []

export { render, staticRenderFns }